import { render, staticRenderFns } from "./practice.vue?vue&type=template&id=3ebb80a8&scoped=true"
import script from "./practice.vue?vue&type=script&lang=js"
export * from "./practice.vue?vue&type=script&lang=js"
import style0 from "../css/practice.scss?vue&type=style&index=0&id=3ebb80a8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebb80a8",
  null
  
)

export default component.exports